//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.20.0.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming
import * as Types from '../axios-client';
import { useQuery, useMutation } from '@tanstack/react-query';
import type { UseQueryResult, QueryFunctionContext, UseQueryOptions, QueryClient, QueryKey, MutationKey, UseMutationOptions, UseMutationResult, QueryMeta, MutationMeta } from '@tanstack/react-query';
import { trimArrayEnd, isParameterObject, getBaseUrl, addMetaToOptions } from './helpers';
import type { QueryMetaContextValue } from 'react-query-swagger';
import { QueryMetaContext } from 'react-query-swagger';
import { useContext } from 'react';
import * as Client from './AccountClient'
export { Client };
import type { AxiosRequestConfig } from 'axios';



export function accountConfirmEmailUrl(): string {
  let url_ = getBaseUrl() + "/api/account/confirm-email";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function accountConfirmEmailMutationKey(): MutationKey {
  return trimArrayEnd([
      'AccountClient',
      'accountConfirmEmail',
    ]);
}

/**
 * @param body (optional) 
 * @return OK
 */
export function useAccountConfirmEmailMutation<TContext>(options?: Omit<UseMutationOptions<void, unknown, Types.ConfirmEmailInput, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<void, unknown, Types.ConfirmEmailInput, TContext> {
  const key = accountConfirmEmailMutationKey();
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: (body: Types.ConfirmEmailInput) => Client.accountConfirmEmail(body),
    mutationKey: key,
  });
}
  
export function accountDeleteAccountUrl(): string {
  let url_ = getBaseUrl() + "/api/account";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function accountDeleteAccountMutationKey(): MutationKey {
  return trimArrayEnd([
      'AccountClient',
      'accountDeleteAccount',
    ]);
}

/**
 * @return OK
 */
export function useAccountDeleteAccountMutation<TContext>(options?: Omit<UseMutationOptions<void, unknown, void, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<void, unknown, void, TContext> {
  const key = accountDeleteAccountMutationKey();
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: () => Client.accountDeleteAccount(),
    mutationKey: key,
  });
}
  
export function accountRegisterUrl(): string {
  let url_ = getBaseUrl() + "/api/account/register";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function accountRegisterMutationKey(): MutationKey {
  return trimArrayEnd([
      'AccountClient',
      'accountRegister',
    ]);
}

/**
 * @param body (optional) 
 * @return OK
 */
export function useAccountRegisterMutation<TContext>(options?: Omit<UseMutationOptions<Types.IdentityUserDto, unknown, Types.RegisterDto, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<Types.IdentityUserDto, unknown, Types.RegisterDto, TContext> {
  const key = accountRegisterMutationKey();
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: (body: Types.RegisterDto) => Client.accountRegister(body),
    mutationKey: key,
  });
}
  
export function accountSendPasswordResetCodeUrl(): string {
  let url_ = getBaseUrl() + "/api/account/send-password-reset-code";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function accountSendPasswordResetCodeMutationKey(): MutationKey {
  return trimArrayEnd([
      'AccountClient',
      'accountSendPasswordResetCode',
    ]);
}

/**
 * @param body (optional) 
 * @return OK
 */
export function useAccountSendPasswordResetCodeMutation<TContext>(options?: Omit<UseMutationOptions<void, unknown, Types.SendPasswordResetCodeDto, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<void, unknown, Types.SendPasswordResetCodeDto, TContext> {
  const key = accountSendPasswordResetCodeMutationKey();
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: (body: Types.SendPasswordResetCodeDto) => Client.accountSendPasswordResetCode(body),
    mutationKey: key,
  });
}
  
export function accountVerifyPasswordResetTokenUrl(): string {
  let url_ = getBaseUrl() + "/api/account/verify-password-reset-token";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function accountVerifyPasswordResetTokenMutationKey(): MutationKey {
  return trimArrayEnd([
      'AccountClient',
      'accountVerifyPasswordResetToken',
    ]);
}

/**
 * @param body (optional) 
 * @return OK
 */
export function useAccountVerifyPasswordResetTokenMutation<TContext>(options?: Omit<UseMutationOptions<boolean, unknown, Types.VerifyPasswordResetTokenInput, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<boolean, unknown, Types.VerifyPasswordResetTokenInput, TContext> {
  const key = accountVerifyPasswordResetTokenMutationKey();
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: (body: Types.VerifyPasswordResetTokenInput) => Client.accountVerifyPasswordResetToken(body),
    mutationKey: key,
  });
}
  
export function accountResetPasswordUrl(): string {
  let url_ = getBaseUrl() + "/api/account/reset-password";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function accountResetPasswordMutationKey(): MutationKey {
  return trimArrayEnd([
      'AccountClient',
      'accountResetPassword',
    ]);
}

/**
 * @param body (optional) 
 * @return OK
 */
export function useAccountResetPasswordMutation<TContext>(options?: Omit<UseMutationOptions<void, unknown, Types.ResetPasswordDto, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<void, unknown, Types.ResetPasswordDto, TContext> {
  const key = accountResetPasswordMutationKey();
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: (body: Types.ResetPasswordDto) => Client.accountResetPassword(body),
    mutationKey: key,
  });
}